export enum MobileOS {
  Android = 'Android',
  iOS = 'iOS',
}
